import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { AlertService } from '../../store/services/alert.service';
import { FirestoreService } from '../../shared/firestore/firestore.service';
import { IProject, FireStoreProject } from '../../shared/firestore/models/project';
import { AuthService } from '../../store/services/auth.service';
import { IUser } from '../../shared/firestore/models/user';

@Component({
  selector: 'app-project-card',
  templateUrl: './project-card.component.html',
  styleUrls: ['./project-card.component.sass']
})
export class ProjectCardComponent implements OnInit {
  @Input() project: IProject;
  @Input() isMainProject: boolean;
  @Input() userId: string;
  @Output() invite = new EventEmitter();
  name: string;
  firestoreProject: FireStoreProject;

  constructor(
    private auth: AuthService,
    private alert: AlertService,
    private firestore: FirestoreService,
  ) { }

  ngOnInit() {
    this.name = this.project.name;
    this.firestoreProject = this.firestore.findProject(this.project.id);
  }

  onInvite() {
    this.invite.emit(this.project);
  }

  update(projectForm, event: Event) {
    event.preventDefault();
    this.firestoreProject.update(<IProject>{name: this.name});
    this.alert.success('プロジェクトを更新しました');
  }

  toMainProject() {
    const firestoreUser$ = this.auth.getUserProfile().map(profile =>
      this.firestore.findUser(profile.userId));
    firestoreUser$
      .do(store =>
        store.update(<IUser>{ mainProjectId: this.project.id }))
      .subscribe(() =>
        this.alert.success('メインプロジェクトにしました'));
  }

}



// WEBPACK FOOTER //
// /Users/shwld/project/shwld/home-counter/app_src/src/app/components/project-card/project-card.component.ts